module.exports = __webpack_public_path__ + "static/media/car-finished.947948ec.svg";